import {
  NgxMatColorPickerModule,
  MAT_COLOR_FORMATS,
  NGX_MAT_COLOR_FORMATS,
} from "@angular-material-components/color-picker";
import { CommonModule, PercentPipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatSelectModule } from "@angular/material/select";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { CustomTableModule } from "src/app/shared/modules/custom-table/custom-table.module";
import { TopCardMaterialModule } from "src/app/shared/modules/top-card-material/top-card-material.module";
import { FormatPipe } from "src/app/shared/pipes/formatPipe";
import { FuelingModeDetailsComponent } from "./fueling-mode-details/fueling-mode-details.component";

import { FuelingModeListComponent } from "./fueling-mode-list/fueling-mode-list.component";
import { FuelingModeRoutingModule } from "./fueling-mode-routing.module";

@NgModule({
  imports: [
    CommonModule,
    FuelingModeRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    CustomTableModule,
    TopCardMaterialModule,
    NgxMatColorPickerModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatGridListModule,
    MatInputModule,
    MatTabsModule,
    MatSelectModule,
    MatCheckboxModule,
    MatCardModule,
    MatProgressBarModule,
    FlexLayoutModule,
  ],
  declarations: [FuelingModeListComponent, FuelingModeDetailsComponent],
  providers: [
    { provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS },
    FormatPipe,
    PercentPipe,
  ],
})
export class FuelingModeModule {}
